export default "__VITE_ASSET__oBBQ3Gsa__"